/** @jsx jsx */

import { forwardRef } from 'react';
import { css, jsx } from '@emotion/core';

import { Icon } from '@zapier/zinnia-icons';
import { Colors, Text } from '@zapier/design-system';

enum MODE_TEXTS {
  code = 'Switch to Code Mode',
  form = 'Switch to Form Mode',
}

const Styles = {
  root: css`
    margin: 0px;
    background-color: ${Colors.GrayWarm2};
    background-image: initial;
    border-radius: 0 0 3px 3px;
    border-bottom: 0;
    border-left: 0;
    border-right: 0;
    border-top: 1px solid ${Colors.GrayWarm3};
    display: flex;
    align-items: center;
    text-align: left;
    width: 100%;
    padding: 1em;

    &:focus,
    &:active {
      outline: var(--zds-border-focus);
    }
    &:hover {
      background-color: ${Colors.GrayWarm3};
      background-image: initial;
      color: ${Colors.GrayWarm7};
    }
  `,
};

type Props = {
  isCode: boolean;
  labelText: string;
  onClick?: (event?: React.SyntheticEvent) => void;
};

const ToggleButton = forwardRef<HTMLButtonElement, Props>(function ToggleButton(
  { isCode, labelText, onClick, ...rest },
  ref
) {
  return (
    <button
      {...rest}
      ref={ref}
      aria-label={`${labelText} - ${
        isCode ? MODE_TEXTS.form : MODE_TEXTS.code
      } Toggle`}
      css={Styles.root}
      onClick={onClick}
    >
      <Icon name={isCode ? 'arrowCode' : 'miscList'} size={20} />
      <Text fontWeight={600} margin="0px 0px 0px 20px">
        {isCode ? MODE_TEXTS.form : MODE_TEXTS.code}
      </Text>
    </button>
  );
});

export default ToggleButton;
